export * from './IconAlignBlocksLeft';
